import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import Tooltip from "../Common/Tooltip";
import { validationService } from "../../Services/validation.service";
import {
  email,
  PIN,
  numbersOnly,
  lettersOnly,
  lettersAndNumbers,
  OIB,
} from "../../Config/Regex";
import { Modal } from "react-bootstrap";

const UserData = (props) => {
  const { values, createUserData, setCreateUserData } = props;
  const { register, handleSubmit, errors } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const goTo = (data) => {
    setCreateUserData({
      ...createUserData,
      loginName: data.loginName,
      realName: data.realName,
      printName: data.printName,
      personalIdentificationNumber: data.personalIdentificationNumber,
      phone: data.phone,
      email: data.email,
      pin: data.pin,
      roleId: 4,
      posPriceEdit: data.posPriceEdit,
      posDiscountEdit: data.posDiscountEdit,
      rfidTag: data.RFIDtag,
    });
    props.nextStep();
  };

  const back = () => {
    props.prevStep();
  };

  const handleHide = () => {
    setCreateUserData({
      userId: null,
      loginName: "",
      realName: "",
      printName: "",
      personalIdentificationNumber: "",
      phone: "",
      email: "",
      pin: "",
      roleId: 4,
      posPriceEdit: true,
      posDiscountEdit: true,
      rfidTag: "",
    });

    setShowModal(false);
  };

  const { t: translator } = useTranslation();
  const [pinType, setPinType] = useState("password");
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <div className="row">
        <div className="col-lg-4">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              {translator("Onboarding-UserData-PersonalData")}
            </legend>
            <div className="form-group">
              <label>{translator("Onboarding-UserData-Role")}</label>{" "}
              <Tooltip text={translator("UserDataRole-Msg")} />
              <input
                type="text"
                disabled
                className="form-control"
                value={translator("Owner")}
              />
            </div>
            <div className="form-group">
              <label htmlFor="personalIdentificationNumber">
                {translator("Onboarding-UserData-OIB")}
              </label>{" "}
              <Tooltip text={translator("UserDataOIB-Msg")} />
              <input
                type="text"
                className="form-control"
                name="personalIdentificationNumber"
                ref={register({
                  required: true,
                  pattern: OIB,
                  validate: () =>
                    validationService
                      .validateUserOib(
                        document.getElementsByName(
                          "personalIdentificationNumber"
                        )[0].value
                      )
                      .then((res) => {
                        if (res.roleId === 4) {
                          setCreateUserData({
                            userId: res.userId,
                            loginName: res.loginName,
                            realName: res.realName,
                            printName: res.printName,
                            personalIdentificationNumber:
                              res.personalIdentificationNumber,
                            phone: res.phone,
                            email: res.email,
                            pin: res.pin,
                            roleId: res.roleId,
                            posPriceEdit: res.posPriceEdit,
                            posDiscountEdit: res.posDiscountEdit,
                          });
                          setShowModal(true);
                        } else return res;
                      })
                      .catch((err) => console.log(err)),
                })}
                defaultValue={createUserData.personalIdentificationNumber}
              />
              {errors.personalIdentificationNumber &&
                errors.personalIdentificationNumber.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
              {errors.personalIdentificationNumber &&
                errors.personalIdentificationNumber.type === "validate" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-OIBNotValid")}
                  </p>
                )}
              {errors.personalIdentificationNumber &&
                errors.personalIdentificationNumber.type === "pattern" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-OIBLength")}
                  </p>
                )}
            </div>
            <div className="form-group">
              <label htmlFor="realName">
                {translator("Onboarding-UserData-FullName")}
              </label>{" "}
              <Tooltip text={translator("UserDataFullName-Msg")} />
              <input
                type="text"
                className="form-control"
                name="realName"
                ref={register({
                  required: true,
                  maxLength: 50,
                  pattern: lettersOnly,
                })}
                defaultValue={createUserData.realName}
              />
              {errors.realName && errors.realName.type === "required" && (
                <p className="text-danger">
                  {translator("ValidationMsg-RequiredField")}
                </p>
              )}
              {errors.realName && errors.realName.type === "maxLength" && (
                <p className="text-danger">
                  {translator("ValidationMsg-MaxLength50")}
                </p>
              )}
              {errors.realName && errors.realName.type === "pattern" && (
                <p className="text-danger">
                  {translator("ValidationMsg-LettersOnly")}
                </p>
              )}
            </div>
          </fieldset>
        </div>
        <div className="col-lg-4">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              {translator("Onboarding-UserData-UserData")}
            </legend>
            <div className="form-group">
              <label htmlFor="printName">
                {translator("Onboarding-UserData-PrintName")}
              </label>{" "}
              <Tooltip text={translator("UserDataPrintname-Msg")} />
              <input
                type="text"
                className="form-control"
                name="printName"
                ref={register({
                  required: true,
                  pattern: lettersAndNumbers,
                  maxLength: 20,
                })}
                defaultValue={createUserData.printName}
              />
              {errors.printName && errors.printName.type === "required" && (
                <p className="text-danger">
                  {translator("ValidationMsg-RequiredField")}
                </p>
              )}
              {errors.printName && errors.printName.type === "pattern" && (
                <p className="text-danger">
                  {translator("ValidationMsg-LettersAndNumbers")}
                </p>
              )}
              {errors.printName && errors.printName.type === "maxLength" && (
                <p className="text-danger">
                  {translator("ValidationMsg-MaxLength20")}
                </p>
              )}
            </div>
            <div className="form-row">
              <div className="form-group col-md-6 col-xs-12">
                <label htmlFor="loginName">
                  {translator("Onboarding-UserData-UserName")}
                </label>{" "}
                <Tooltip text={translator("UserDataUsername-Msg")} />
                <input
                  type="text"
                  className="form-control"
                  name="loginName"
                  ref={register({
                    required: true,
                    pattern: lettersAndNumbers,
                    maxLength: 20,
                    minLength: 4,
                    validate: () =>
                      validationService.validateLoginName(
                        document.getElementsByName("loginName")[0].value
                      ),
                  })}
                  defaultValue={createUserData.loginName}
                />
                {errors.loginName && errors.loginName.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
                {errors.loginName && errors.loginName.type === "pattern" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-LettersAndNumbers")}
                  </p>
                )}
                {errors.loginName && errors.loginName.type === "validate" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-User-LoginName")}
                  </p>
                )}
                {errors.loginName && errors.loginName.type === "minLength" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-MinLength4")}
                  </p>
                )}
                {errors.loginName && errors.loginName.type === "maxLength" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-MaxLength20")}
                  </p>
                )}
              </div>

              {/* <div className="form-row"> */}
              {/* <div className="form-group col-md-6 col-xs-12">
                <label>{translator("Users-Create-RFIDtag")}</label>{" "}
                <Tooltip text={translator("Users-Create-TooltipRFIDtageMsg")} />
                <input
                  type="text"
                  className="form-control"
                  ref={register({
                    required: true,
                    pattern: numbersOnly,
                    maxLength: 10,
                  })}
                  name="RFIDtag"
                  defaultValue={createUserData.rfidTag}
                />
                {errors.RFIDtag &&
                  errors.RFIDtag.type === "lettersAndNumbers" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-NumbersOnly")}
                    </p>
                  )}
                {errors.RFIDtag && errors.RFIDtag.type === "maxLength" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-MaxLength10")}
                  </p>
                )}
              </div> */}
              <div className="form-group col-md-6 col-xs-12">
                <label htmlFor="pin">PIN</label>{" "}
                <Tooltip text={translator("UserDataPIN-Msg")} />
                <input
                  type={pinType}
                  className="form-control"
                  name="pin"
                  ref={register({ required: true, pattern: PIN })}
                  defaultValue={createUserData.pin}
                />
                <span
                  className="show-pin-onboarding"
                  onMouseDown={() => setPinType("text")}
                  onMouseUp={() => setPinType("password")}
                  onMouseLeave={() => setPinType("password")}
                  onTouchStart={() => setPinType("text")}
                  onTouchCancel={() => setPinType("password")}
                >
                  <i class="fas fa-eye text-dark"></i>
                </span>
                {errors.pin && errors.pin.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
                {errors.pin && errors.pin.type === "pattern" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-PIN")}
                  </p>
                )}
              </div>
            </div>
            {/* </div> */}
            <div className="form-group">
              <label htmlFor="phone">
                {translator("Onboarding-UserData-PhoneNumber")}
              </label>{" "}
              <Tooltip text={translator("UserDataPhoneNumber-Msg")} />
              <input
                type="text"
                className="form-control"
                name="phone"
                ref={register({
                  required: true,
                  pattern: numbersOnly,
                  maxLength: 20,
                })}
                defaultValue={createUserData.phone}
              />
              {errors.phone && errors.phone.type === "required" && (
                <p className="text-danger">
                  {translator("ValidationMsg-RequiredField")}
                </p>
              )}
              {errors.phone && errors.phone.type === "pattern" && (
                <p className="text-danger">
                  {translator("ValidationMsg-PhoneNumber")}
                </p>
              )}
              {errors.phone && errors.phone.type === "maxLength" && (
                <p className="text-danger">
                  {translator("ValidationMsg-MaxLength20")}
                </p>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="email">Email</label>{" "}
              <Tooltip text={translator("UserDataEmail-Msg")} />
              <input
                type="text"
                className="form-control"
                name="email"
                ref={register({
                  required: true,
                  pattern: email,
                  maxLength: 50,
                })}
                defaultValue={createUserData.email}
              />
              {errors.email && errors.email.type === "required" && (
                <p className="text-danger">
                  {translator("ValidationMsg-RequiredField")}
                </p>
              )}
              {errors.email && errors.email.type === "pattern" && (
                <p className="text-danger">
                  {translator("ValidationMsg-Email")}
                </p>
              )}
              {errors.email && errors.email.type === "maxLength" && (
                <p className="text-danger">
                  {translator("ValidationMsg-MaxLength50")}
                </p>
              )}
            </div>
          </fieldset>
        </div>
        <div className="col-lg-4">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              {translator("Users-Create-MoreInformation")}
            </legend>
            <div className="form-group">
              <label className="labelCont">
                <input
                  ref={register}
                  type="checkbox"
                  name="posPriceEdit"
                  defaultChecked={createUserData.posPriceEdit}
                />
                <span className="checkmark"></span>
              </label>
              <span className="Data">{translator("AddUser-PriceEditing")}</span>{" "}
              <Tooltip text={translator("UserDataPriceEditing-Msg")} />
            </div>
            <div className="form-group">
              <label className="labelCont">
                <input
                  ref={register}
                  type="checkbox"
                  name="posDiscountEdit"
                  defaultChecked={createUserData.posDiscountEdit}
                />
                <span className="checkmark"></span>
              </label>
              <span className="Data">
                {translator("AddUser-DiscountEditing")}
              </span>{" "}
              <Tooltip text={translator("UserDataDiscountEditing-Msg")} />
            </div>
          </fieldset>
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-6">
          <button className="btn btn-outline-secondary" onClick={back}>
            {translator("Onboarding-Btn-Back")}
          </button>
        </div>
        <div className="col-6 text-right">
          <button className="btn btn-primary" onClick={handleSubmit(goTo)}>
            {translator("Onboarding-Btn-Next")}
          </button>
        </div>
      </div>
      <Modal
        size="lg"
        show={showModal}
        onHide={handleHide}
        backdrop="static"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{translator("User-Details")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h6>{translator("SelectedOib-User")}:</h6>
          <hr />
          <div className="row">
            <div className="col-6">
              <p>
                <b>OIB:</b> {createUserData.personalIdentificationNumber}
              </p>
              <p>
                <b>{translator("Onboarding-UserData-FullName")}:</b>{" "}
                {createUserData.realName}
              </p>
              <p>
                <b>{translator("Onboarding-UserData-PrintName")}:</b>{" "}
                {createUserData.printName}
              </p>
              <p>
                <b>{translator("Onboarding-UserData-UserName")}:</b>{" "}
                {createUserData.loginName}
              </p>
            </div>
            <div className="col-6">
              <p>
                <b>Email:</b>
                {createUserData.email}
              </p>
              <p>
                <b>{translator("Onboarding-UserData-PhoneNumber")}:</b>{" "}
                {createUserData.phone}
              </p>
              <p>
                <b>PIN:</b> {createUserData.pin}
              </p>
            </div>
          </div>
          <p>{translator("WantToContinue")}?</p>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-outline-secondary"
            data-dismiss="modal"
            onClick={handleHide}
          >
            {translator("Users-DeleteModal-Cancel")}
          </button>
          <button
            onClick={props.nextStep}
            type="button"
            className="btn btn-primary"
          >
            {translator("Onboarding-Btn-Next")}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default UserData;
